document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('gcb-submit-btn');
  if (!btn) return;

  btn.addEventListener('click', async () => {
    const input = document.getElementById('gcb-code-input').value.trim();
    const err = document.getElementById('gcb-error-msg');
    const res = document.getElementById('gcb-result-area');

    if (!input) return;

    // Odczytywanie zmiennych przekazanych z pliku Liquid
    const config = window.giftCardConfig;

    btn.innerText = config.textBtnLoading;
    btn.disabled = true;
    err.style.display = 'none';
    res.style.display = 'none';

    try {
      const response = await fetch(config.apiUrl, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ code: input })
      });
      
      const data = await response.json();

      if (data.success) {
        const d = data.data;
        
        document.getElementById('gcb-masked-code').innerText = d.maskedCode;
        
        const badge = document.getElementById('gcb-status-badge');
        badge.innerText = d.enabled ? config.textStatusEnabled : config.textStatusDisabled;
        badge.style.background = d.enabled ? config.bgEnabled : config.bgDisabled;
        
        document.getElementById('gcb-balance-value').innerText = `${d.currency} ${d.balance}`;
        document.getElementById('gcb-initial').innerText = `${d.currency} ${d.initialAmount}`;
        document.getElementById('gcb-created').innerText = d.createdAt;
        document.getElementById('gcb-expires').innerText = d.expires === 'Never' ? config.textValNever : d.expires;

        res.style.display = 'block';
      } else {
        const errorCode = data.error_code || 'SERVER_ERROR';
        err.innerText = config.errTexts[errorCode] || config.errTexts['SERVER_ERROR'];
        err.style.display = 'block';
      }
    } catch (e) {
      err.innerText = config.errTexts['SERVER_ERROR'];
      err.style.display = 'block';
      console.error(e);
    } finally {
      btn.innerText = config.textBtnDefault;
      btn.disabled = false;
    }
  });
});